import React, { useState, useContext, useEffect } from 'react';
import { Button } from 'primereact/button';
import { InputNumber } from 'primereact/inputnumber';
import { AuthContext } from '../context/AuthContext';
import { apiService, setupInterceptors } from '../services/apiService';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';


import HeaderComponent from './HeaderComponent';
import TablaPresupuesto from './TablaPresupuesto';
import ListadoPreciosConfirmacion from './ListadoPreciosConfirmacion';
import ClientePresupuesto from './ClientePresupuesto';
import ModalContainer from './ModalContainer';
import FormNuevoCliente from './FormNuevoCliente';

const ListadoPrecios = ({ toast, setLoading, setConfirmDialog }) => {
    const [selectedProducts, setSelectedProducts] = useState([]);
    const { logoutUser } = useContext(AuthContext);
    const [productos, setProductos] = useState([]);
    const [vistaPrincipal, setVistaPrincipal] = useState(true);
    const [productosPresupuesto, setProductosPresupuesto] = useState([]);
    const [descuentoGlobal, setDescuentoGlobal] = useState(0); // Descuento global a aplicar
    const [ clientes, setClientes ] = useState([])
    const [ clienteSeleccionado, setClienteSeleccionado ] = useState(null)

    const [showModalCliente, setShowModalCliente] = useState(false);

    const openModalCliente = () => setShowModalCliente(true);
    const hideModalCliente = () => setShowModalCliente(false);


    const getProductos = async () => {
        try {
            const response = await apiService.fetchData('productos/');
            const productosList = response.data.map(producto => ({
                id: producto.id,
                categoria_nombre: producto.categoria_nombre,
                codigo: producto.codigo,
                nombre: producto.nombre,
                fabricante: producto.fabricante,
                precio_producto: producto.precio_producto,
                ult_actualizacion_precio: producto.ult_actualizacion_precio,
                cantidad_disponible: producto.cantidad_disponible
            }));
            setProductos(productosList); 
        } catch (error) {
            console.error('Error al obtener datos:', error.response ? error.response.data : error.message);
        }
    };

    const getClientes = async () => {
        try {
            const response = await apiService.fetchData('clientes/');
            const clientesList = response.data.map(cliente => ({
                id: cliente.id,
                nombre: cliente.nombre,
            }));
            setClientes(clientesList); 
        } catch (error) {
            console.error('Error al obtener datos:', error.response ? error.response.data : error.message);
        }
    };

    const postClientes = async (data) => {
        try {
            const response = await apiService.postData('clientes/', data);
            const nuevoCliente = {
                id: response.data.id,
                nombre: response.data.nombre,
            };
            
            // Actualiza el estado de las categorías agregando la nueva categoría
            setClientes(prevClientes => [...prevClientes, nuevoCliente]);

            toast.current.show({severity:'success', summary: 'Solicitud Exitosa', detail:'Producto creado exitosamente!', life: 2000});

            
            // Opcional: cierra el modal tras agregar la nueva categoría
            hideModalCliente();

        } catch (error) {
            toast.current.show({severity:'error', summary: 'Error', detail:{error}, life: 3000});
            console.error('Error al realizar la creacion:', error.response ? error.response.data : error.message);
        }
    };

    useEffect(() => {
        // Configura el interceptor con la función de logout
        setupInterceptors(logoutUser);
        getProductos();
        getClientes();
    }, [logoutUser]);

    // Formato de moneda para el precio
    const formatearMoneda = (value) => {
        return value.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' });
    };

    // Manejar el cambio en porcentaje para editar el precio
    const handlePercentageChange = (e, rowData) => {
        const porcentaje = e.value || 0; // Default to 0 if undefined
        const descuento = (rowData.precio_producto * (porcentaje / 100));
        const nuevoPrecio = rowData.precio_producto - descuento; // Aplicar descuento
        
        const updatedProducts = productosPresupuesto.map(product => {
            if (product.id === rowData.id) {
                return {
                    ...product,
                    porcentajeModificado: porcentaje,
                    nuevoPrecio
                };
            }
            return product;
        });
        setProductosPresupuesto(updatedProducts);
    };

    // Generar la tabla de presupuesto con los productos seleccionados
    const generarPresupuesto = () => {
        const productosConPorcentaje = selectedProducts.map(product => ({
            ...product,
            porcentajeModificado: 0, // Porcentaje inicial para editar
            nuevoPrecio: product.precio_producto
        }));
        setProductosPresupuesto(productosConPorcentaje);
        setVistaPrincipal(false);
    };

    // Aplicar descuento global a todos los productos de la tabla
    const aplicarDescuentoGlobal = () => {
        const productosConDescuento = productosPresupuesto.map(product => {
            const descuento = descuentoGlobal / 100;
            const nuevoPrecio = product.precio_producto * (1 - descuento);
            return {
                ...product,
                porcentajeModificado: descuentoGlobal,
                nuevoPrecio
            };
        });
        setProductosPresupuesto(productosConDescuento);
    };

    const postPresupuesto = async (data) => {
        try {
            setLoading(true);

            const response = await apiService.postData('listado_precios/', data);

            setLoading(false);
            setConfirmDialog(true);
            
            toast.current.show({severity:'success', summary: 'Solicitud Exitosa', detail:'Producto creado exitosamente!', life: 2000});

        } catch (error) {
            setLoading(false);

            toast.current.show({severity:'error', summary: 'Error', detail:{error}, life: 3000});
            console.error('Error al realizar la creacion del presupuesto:', error.response ? error.response.data : error.message);
        }
    };

    const confirmarPostPresupuesto = () => {
        confirmDialog({
            message: '¿Está seguro de que desea confirmar el presupuesto?',
            header: 'Confirmación',
            icon: 'pi pi-info-circle',
            acceptLabel:"Confirmar",
            accept: () => {
                // Preparando data...
                const data ={
                    cliente: clienteSeleccionado.id,
                    productosPresupuesto: productosPresupuesto
                }

                postPresupuesto(data)
            },
            reject: () => {
                // Lógica al rechazar (opcional)
                console.log('Confirmación rechazada');
            }
        });
    };


    return (
        <>
            <HeaderComponent title={"Listado de Precios"} />
            {vistaPrincipal ? (
                <>
                    <div className='col-12 ml-6' style={{ minWidth: "95%", maxWidth: "95%" }}>
                        {/* <div className='col-6'> */}
                        {selectedProducts.length > 0 && clienteSeleccionado && (
                                <Button 
                                    size='small' 
                                    label='Generar Presupuesto' 
                                    severity='warning'
                                    onClick={generarPresupuesto}
                                />
                            )}
                        {/* </div> */}
                        <div className='col-12'>
                            <ClientePresupuesto 
                            clientes={clientes} 
                            clienteSeleccionado={clienteSeleccionado} 
                            setClienteSeleccionado={setClienteSeleccionado} 
                            openModalCliente={openModalCliente}
                            />

                        </div>
                        <div className='col-12'>
                            <h3>Productos</h3>
                            <TablaPresupuesto 
                                productos={productos} 
                                selectedProducts={selectedProducts} 
                                setSelectedProducts={setSelectedProducts} 
                            />
                        </div>
                    </div>
                </>
            ) : 
            (
                <div className="col-12 ml-6" style={{ minWidth: "95%", maxWidth: "95%"}}>
                    <div>
                        <Button label='Volver' severity='secondary' onClick={() => setVistaPrincipal(true)}/>
                    </div>
                    <div className='mt-4' >
                        <Button label='Confimar Presupuesto' icon='pi pi-file' size='small' severity='warning' onClick={confirmarPostPresupuesto} />
                    </div>
                    {/* Input para aplicar descuento global */}
                    <div className='col-12' style={{ display:"flex" }}>
                        <div className='col-4'>
                            <p style={{ fontSize:"18px", fontWeight:600 }}>Presupuesto para {clienteSeleccionado.nombre}</p>
                        </div>
                        <div className="col-8 mt-2">
                            <label htmlFor="descuentoGlobal">Descuento Global (%) </label>
                            <InputNumber
                                id="descuentoGlobal"
                                value={descuentoGlobal}
                                onValueChange={(e) => setDescuentoGlobal(e.value)}
                                mode="decimal"
                                minFractionDigits={2}
                                maxFractionDigits={2}
                                inputStyle={{ fontSize:"15px" }}
                            />
                            <Button label="Aplicar Descuento" onClick={aplicarDescuentoGlobal} className="ml-2" size='small' />
                        </div>
                    </div>

                    <ListadoPreciosConfirmacion 
                    productosPresupuesto={productosPresupuesto} handlePercentageChange={handlePercentageChange} formatearMoneda={formatearMoneda}
                    postPresupuesto={postPresupuesto}
                    clienteSeleccionado={clienteSeleccionado}
                    />
                </div>
            )}

            <ModalContainer
                title="Agregar Cliente"
                show={showModalCliente}
                close={hideModalCliente}
                idForm="FormNuevoCliente"
                widthSize="25vw">
                    <FormNuevoCliente postClientes={postClientes} />
            </ModalContainer>
        </>
    );
};

export default ListadoPrecios;
